module.exports = __webpack_public_path__ + "img/xrk.2f8a09bc.png";